let elements = {
  mainImage: {
    imagePath: 'games/page002_game1/img/bcg.jpg',
    pos: {
      y: 0,
      x: 0,
    },
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  fields: [
    {
      pos: {
        y: 878,
        x: 1398,
      },
      width: 90,
      height: 90,
      background: 'transparent',
      // images: [
      //   {
      //     src: 'games/page002_game1/img/dzwiek.png',
      //     pos: {
      //       y: 0,
      //       x: 100,
      //     },
      //     width: 100,
      //     height: 100,
      //   },
      // ],
      // html: '<p style="padding-top: 100px; font-size: 28px">Mysz</p>',
      audio: {
        src: 'games/page002_game1/audio/z2c1-4.mp3',
        volume: 1,
      },
    },
    {
      pos: {
        y: 908,
        x: 28,
      },
      width: 90,
      height: 90,
      background: 'transparent',
      // images: [
      //   {
      //     src: 'games/page002_game1/img/dzwiek.png',
      //     pos: {
      //       y: 0,
      //       x: 100,
      //     },
      //     width: 100,
      //     height: 100,
      //   },
      // ],
      // html: '<p style="padding-top: 100px; font-size: 28px">Klawiatura</p>',
      audio: {
        src: 'games/page002_game1/audio/z2c1-3.mp3',
        volume: 1,
      },
    },
    {
      pos: {
        y: 285,
        x: 1446,
      },
      width: 90,
      height: 90,
      // images: [
      //   {
      //     src: 'games/page002_game1/img/dzwiek.png',
      //     pos: {
      //       y: 0,
      //       x: 100,
      //     },
      //     width: 100,
      //     height: 100,
      //   },
      // ],
      // html: '<p style="padding-top: 100px; font-size: 28px">Jednostka centralna</p>',
      background: 'transparent',
      audio: {
        src: 'games/page002_game1/audio/z2c1-1.mp3',
        volume: 1,
      },
    },
    {
      pos: {
        y: 175,
        x: 570,
      },
      width: 90,
      height: 90,
      background: 'transparent',
      // images: [
      //   {
      //     src: 'games/page002_game1/img/dzwiek.png',
      //     pos: {
      //       y: 0,
      //       x: 100,
      //     },
      //     width: 100,
      //     height: 100,
      //   },
      // ],
      // html: '<p style="padding-top: 100px; font-size: 28px">Monitor</p>',
      audio: {
        src: 'games/page002_game1/audio/z2c1-2.mp3',
        volume: 1,
      },
    },
  ],
  // mbAudioItemData: [
  //   {
  //     src: 'games/page002_game1/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 223,
  //       x: 464,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page002_game1/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 512,
  //       x: 574,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page002_game1/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 333,
  //       x: 1344,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page002_game1/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 773,
  //       x: 1214,
  //     },
  //     unit: 'px',
  //   },
  // ],
};

export default elements;
